import React, { useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';

import { MediaSourcePicker } from './MediaSourcePicker';
import { MotionControls } from './MotionControls';
import { buildInterpolate } from './buildRequests';
import type { VideoPanelProps } from './panelTypes';
import type { MediaSource } from '../../../services/mediaSourceService';

/** First frame + last frame → tweened clip (A-F5). */
export const InterpolatePanel: React.FC<VideoPanelProps> = ({
  controls,
  onControlsChange,
  onSubmit,
  isRendering,
}) => {
  const [firstFrame, setFirst] = useState<MediaSource | null>(null);
  const [lastFrame, setLast] = useState<MediaSource | null>(null);
  const [prompt, setPrompt] = useState('');
  const hasFrames = !!firstFrame && !!lastFrame;
  const canSubmit = !!hasFrames && !isRendering;

  return (
    <Stack spacing={1.5}>
      <MediaSourcePicker kind="image" label="First frame" value={firstFrame} onChange={setFirst} disabled={isRendering} />
      <MediaSourcePicker kind="image" label="Last frame" value={lastFrame} onChange={setLast} disabled={isRendering} />
      <TextField
        label="Prompt (optional)"
        value={prompt}
        onChange={e => setPrompt(e.target.value)}
        size="small"
        fullWidth
      />
      <MotionControls kind="Interpolate" value={controls} onChange={onControlsChange} />
      {!hasFrames && (
        <Typography variant="caption" color="text.secondary">
          Choose a first and a last frame — upload them or pick them from your library.
        </Typography>
      )}
      <Button
        variant="contained"
        disabled={!canSubmit}
        onClick={() =>
          onSubmit(
            'Interpolate',
            buildInterpolate(
              {
                firstFrameImageId: firstFrame!.assetId,
                lastFrameImageId: lastFrame!.assetId,
                prompt,
              },
              controls,
            ),
          )
        }
      >
        {isRendering ? 'Rendering…' : 'Interpolate'}
      </Button>
    </Stack>
  );
};
